import Vue from 'vue'
import VueRouter from 'vue-router'
import Authorize from '../views/Authorize.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/authorize',
    name: 'Authorize',
    component: Authorize
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
    props: true
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "legal" */ '../views/PrivacyPolicy.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfUse',
    component: () => import(/* webpackChunkName: "legal" */ '../views/TermsOfUse.vue')
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "password" */ '../views/ForgotPassword.vue')
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "password" */ '../views/ResetPassword.vue')
  },
  {
    path: '/createaccount',
    name: 'CreateAccount',
    component: () => import(/* webpackChunkName: "createaccount" */ '../views/CreateAccount.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const {create, ...query} = to.query;
  if (to.name === 'Authorize' && create)
    next({path:'/createaccount',query});
  else
    next();
})

export default router
